import styled from 'styled-components';
import SearchIcon from '../../../../new-components/svg-icons/SearchIcon';
import { Dispatch, SetStateAction, useCallback } from 'react';
import debounce from '../../../search/utils';
import { useTranslation } from 'next-i18next';

interface SearchbarProps {
  setSearchTerm: Dispatch<SetStateAction<string>>;
  type: 'offer_type' | 'Developers_Search' | 'Areas_search';
}

const Searchbar = ({ setSearchTerm, type }: SearchbarProps) => {
  const { t } = useTranslation('cityscape');

  const debouncedResults = useCallback(
    debounce((term: string) => {
      setSearchTerm(term);
    }, 500),
    []
  );

  const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    debouncedResults(e.currentTarget.value);
  };

  return (
    <Container>
      <SearchIcon width="17.5px" height="17.5px" fill="#788496" />

      <Input
        placeholder={t(
          type === 'offer_type'
            ? `${type.toLowerCase()}_search`
            : type.toLowerCase()
        )}
        onChange={handleInputChange}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  gap: 8px;
  border: 1px solid #d3dbe6;
  border-radius: 12px;
  background-color: #f7f9fd;
`;

const Input = styled.input`
  border: none;
  background-color: #f7f9fd;
  user-select: none;

  &::placeholder {
    color: #5b6573;
    font-size: 14px;
    font-family: materialRegular;
  }

  &:focus {
    outline: none;
  }
`;

export default Searchbar;
